<div class="card form-right">
  <div class="back">
    <h2>{{ (edit ? "settings.mail.mailboxes.edit" : "settings.mail.mailboxes.add") | translate }}</h2>
    <i class="icon-cross2" (click)="emitBack()"></i>
  </div>

  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Label -->
      <div class="mb-3">
        <label class="form-label">{{ "settings.mail.mailboxes.label" | translate }} *</label>
        <input type="text" class="form-control" formControlName="label"
          [ngClass]="{ 'is-invalid': isFieldInvalid('label') }"
          placeholder="Ej: Soporte, Ventas, Noreply">
      </div>

      <div class="row linea"></div>

      <!-- Host + Port -->
      <div class="row">
        <div class="col-md-8 col-12 mb-3">
          <label class="form-label">{{ "settings.mail.mailboxes.host" | translate }} *</label>
          <input type="text" class="form-control" formControlName="host"
            [ngClass]="{ 'is-invalid': isFieldInvalid('host') }"
            placeholder="smtp.mailgun.org">
        </div>
        <div class="col-md-4 col-12 mb-3">
          <label class="form-label">{{ "settings.mail.mailboxes.port" | translate }} *</label>
          <input type="number" class="form-control" formControlName="port"
            [ngClass]="{ 'is-invalid': isFieldInvalid('port') }"
            placeholder="587">
        </div>
      </div>

      <!-- Username + Password -->
      <div class="row">
        <div class="col-md-6 col-12 mb-3">
          <label class="form-label">{{ "settings.mail.mailboxes.username" | translate }}</label>
          <input type="text" class="form-control" formControlName="username">
        </div>
        <div class="col-md-6 col-12 mb-3">
          <label class="form-label">{{ "settings.mail.mailboxes.password" | translate }} <span *ngIf="!edit">*</span></label>
          <input type="password" class="form-control" formControlName="password"
            [ngClass]="{ 'is-invalid': isFieldInvalid('password') }"
            [placeholder]="edit ? '••••••••' : ''">
          <small *ngIf="edit" class="text-muted">{{ "settings.mail.mailboxes.password_hint" | translate }}</small>
        </div>
      </div>

      <!-- Encryption + From Address + From Name -->
      <div class="row">
        <div class="col-md-4 col-12 mb-3">
          <label for="encryption" class="form-label">{{ "settings.mail.mailboxes.encryption" | translate }}</label>
          <div class="input-group">
          <select id="encryption" class="form-control" formControlName="encryption">
            <option value="" disabled selected>{{ "inputs.select_option" | translate }}</option>
            <option value="tls">TLS</option>
            <option value="ssl">SSL</option>
            <option value="null">{{ "settings.mail.mailboxes.none_encryption" | translate }}</option>
          </select>
          </div>
        </div>
        <div class="col-md-4 col-12 mb-3">
          <label class="form-label">{{ "settings.mail.mailboxes.from_address" | translate }} *</label>
          <input type="email" class="form-control" formControlName="from_address"
            [ngClass]="{ 'is-invalid': isFieldInvalid('from_address') }"
            placeholder="noreply@ejemplo.com">
        </div>
        <div class="col-md-4 col-12 mb-3">
          <label class="form-label">{{ "settings.mail.mailboxes.from_name" | translate }}</label>
          <input type="text" class="form-control" formControlName="from_name"
            placeholder="Mi Empresa">
        </div>
      </div>

      <div class="row linea"></div>

      <!-- Is Default -->
      <div class="mb-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="is_default" formControlName="is_default">
          <label class="form-check-label" for="is_default">
            {{ "settings.mail.mailboxes.is_default" | translate }}
          </label>
        </div>
      </div>

      <!-- Submit -->
      <div class="btn-izq">
        <button type="submit" class="btn btn-hover" [disabled]="form.invalid">
          {{ (edit ? "buttons.save" : "buttons.configure") | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
